import { CITIES, FIRST_CITY } from '../../lib/content'
import { Reveal } from '../ui/Reveal'
import { SectionHead } from '../ui/SectionHead'
import './Cities.css'

interface Props { votes: Record<string, boolean>; onVote: (city: string) => void }

export function Cities({ votes, onVote }: Props) {
  return (
    <section id="cities">
      <div className="wrap">
        <SectionHead eyebrow="Cities" title={<>Starting <em className="s">across India.</em></>}>
          We're building city by city, starting with Delhi NCR. Tap your city to move it up the list.
        </SectionHead>
        <Reveal className="cities">
          {CITIES.map((c) =>
            c === FIRST_CITY ? (
              <span key={c} className="city ea">{c}<span className="tag neon-tag-dark">Starting here</span></span>
            ) : (
              <button key={c} type="button" className="city glass thin" aria-pressed={!!votes[c]} onClick={() => onVote(c)}>
                {c}{votes[c] && <span className="v">+1 vote</span>}
              </button>
            ),
          )}
        </Reveal>
        <Reveal as="p" className="world">Then the rest of the world. Same map, every city.</Reveal>
      </div>
    </section>
  )
}
